import addDays, { format } from "date-fns";
import React from "react";
import {
  Dimensions,
  Image,
  Linking,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import { color } from "react-native-reanimated";
import Text from "@components/CustomText";
import colors from "@constants/color";
// import WAShareOrder from "@components/WAShareOrder";
import metrics from "@constants/metrics";
import { orderStatusColor, orderStatusToHindi } from "@utils/converters";
import OrderStatus from "@assets/svg/OrderStatus";
import t from "@constants/localization";
import Button from "../../Form/Button";

const PATH = "screens/SupportTree/components/OrderList/View/OrderCard";

const { width } = Dimensions.get("window");

export const showLimitedImages = (imgs = [], limit = 3) => {
  if (!imgs.length || limit <= 0) return;
  const totalImages = imgs.length;
  const toShowOnlyArr = imgs.slice(0, limit);
  return (
    <>
      {toShowOnlyArr.map((imageUrl, imageIndex) => (
        <Image
          key={imageIndex}
          source={{ uri: imageUrl }}
          style={styles.image}
        />
      ))}
      {toShowOnlyArr.length < totalImages && (
        <View style={styles.nMoreBox}>
          <Text style={{ color: colors.lightBlack }}>
            +{+totalImages - limit}
          </Text>
        </View>
      )}
    </>
  );
};

const OrderCard = (props) => {
  const {
    order = {},
    showUserName = true,
    onPressOrder,
    selectButtonText = t(`${PATH}/chooseOrder`),
  } = props;
  const { user_phone = "" } = order || {};
  const orderedDate = format(new Date(order.created_at), "dd/MM/yyyy");
  const deliveryDate = format(
    addDays(new Date(order.created_at), 2),
    "dd/MM/yyyy",
  );

  const { items } = order;

  const shouldShowDeliveryDate = (orderStatus) => {
    if (orderStatus === "PENDING") {
      return `Delivery by ${deliveryDate}`;
    }
    return "";
  };

  const imagesList =
    order && order.items && order.items.map((item) => item.product_image);
  // alert(JSON.stringify("orderITEMS" + order.items, null, 2));

  return (
    <View style={styles.orderCardContainer}>
      <View style={styles.topContainer}>
        <View style={styles.orderIdContainer}>
          <Text
            variant="body_text_3"
            style={{
              color: colors.lightBlack,
            }}
          >
            {t(`${PATH}/orderNo`)}
            <Text
              variant="body_text_2"
              style={{ color: "black" }}
            >{` ${order.order_id}`}</Text>
          </Text>
        </View>
        <Text variant="body_text_3" style={{ color: colors.lightBlack }}>
          {t(`${PATH}/orderDate`)}
          <Text
            variant="body_text_2"
            style={{
              color: "black",
            }}
          >
            {` ${orderedDate}`}
          </Text>
        </Text>
      </View>
      <Text
        variant="body_text_2"
        style={{
          marginBottom: 10,
          color: colors.lightBlack,
        }}
      >
        {order.num_items} {t(`${PATH}/items`)} • {order.num_quantity}{" "}
        {t(`${PATH}/quantity`)}
      </Text>
      <View style={styles.imageContainer}>
        <ScrollView horizontal>
          {imagesList && showLimitedImages(imagesList, 3)}
        </ScrollView>

        <Button
          formItem={{ label: t(`${PATH}/chooseOrder`) }}
          height={30}
          onSubmit={() => {
            onPressOrder(order);
          }}
          buttonStyle={{ height: 30, width: 100 }}
          buttonWidth={120}
          borderRadius={8}
        />
      </View>
      <View style={styles.namePriceContainer}>
        {showUserName && (
          <Text style={styles.namePriceText}>
            {order.user_name ? order.user_name : ""}
          </Text>
        )}
        <Text variant="subtitle_16" style={styles.namePriceText}>
          ₹{parseInt(order.collectible_amount, 10)}
        </Text>
      </View>
      <View style={styles.phonePaymentContainer}>
        <TouchableOpacity
          onPress={() =>
            Linking.openURL(`whatsapp://send?phone=+91${user_phone}`)
          }
        >
          <View style={styles.whatsappContainer}>
            <Text style={{ color: colors.mediumBlack }}>
              +91 - {user_phone}
            </Text>
          </View>
        </TouchableOpacity>
        <View>
          <Text variant="body_text_3" style={{ color: colors.lightBlack }}>
            {order.payment_status}
          </Text>
        </View>
      </View>

      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        <View style={{ justifyContent: "center" }}>
          <View
            style={{ flexDirection: "row", paddingTop: 8, paddingBottom: 20 }}
          >
            <OrderStatus orderStatus={order.order_status_icon} />
            <Text
              variant="subtitle_16"
              style={{
                marginLeft: 6,
                color: order.order_status_color,
              }}
            >
              {order.order_status}
            </Text>
          </View>

          {/* <Text  style={{ color: colors.lightBlack }}>
            {shouldShowDeliveryDate(order && order.order_status)}
          </Text> */}
        </View>
      </View>
    </View>
  );
};

export default OrderCard;

const styles = StyleSheet.create({
  orderCardContainer: {
    flex: 1,
    flexDirection: "column",
    marginBottom: 10,
    paddingHorizontal: 10,
    width: width * 0.95,
    backgroundColor: colors.white,
    borderColor: "transparent",
    borderBottomColor: "#F6F7F9",
    borderBottomWidth: 5,
  },
  orderIdContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  topContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 10,
  },
  imageContainer: {
    flex: 3,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: 10,
  },
  image: {
    marginRight: 5,
    height: 50,
    width: 50,
    borderWidth: 1,
    borderColor: colors.lighterBlack,
  },
  nMoreBox: {
    // marginLeft: 10,
    height: 40,
    width: 40,
    alignItems: "center",
    justifyContent: "center",
  },
  namePriceContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    // paddingBottom: 10,
  },
  whatsappContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  namePriceText: {
    fontSize: 16,
    color: colors.mediumBlack,
  },
  phonePaymentContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    // paddingBottom: 10
  },
  dotContainer: {
    height: 8,
    width: 8,
    backgroundColor: colors.lightBlack,
    borderRadius: 4,
    marginRight: 5,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  waShareButton: {
    width: metrics.screenWidth * 0.1,
    marginRight: 10,
  },
});
